var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile-banner"},[_c('WELogo',{attrs:{"searching":"true"}}),_c('p',[_vm._v("- This application is best viewed on larger screens -")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }